import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  IReportingGroupMappingOption,
  getReportingGroupMappingOptions,
} from '../services/reports';

export const useReportingGroupMappingOptions = (active: boolean) => {
  const { surveyId } = useParams();
  const [mappingOptions, setMappingOptions] = useState<IReportingGroupMappingOption[]>([]);

  useEffect(() => {
    if (!active || !surveyId) return;

    let isStale = false;

    (async () => {
      try {
        const options = await getReportingGroupMappingOptions(surveyId);
        if (!isStale) {
          setMappingOptions(options);
        }
      } catch (e) {
        if (!isStale) {
          setMappingOptions([]);
        }
      }
    })();

    return () => {
      isStale = true;
    };
  }, [active, surveyId]);

  return { mappingOptions };
};
